<template>
	<div id="app">
		<!-- <transition name="fade" mode="out-in">
 -->			<router-view />
	<!-- 	</transition> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {

			};
		},
		methods: {

		}
	}
</script>

<style>
	/* 抽屉头部 */
	.el-drawer__header{
		margin-bottom: 0px!important;
	}
	.el-dialog__header{
		margin: 0px!important;
		padding: 15px 20px!important;
		background-color:#409EFF;
		color:#fff;
	}
	.el-avatar>img{
		width: 100%;
		height: 100%;
	}
	body {
		margin: 0px !important;
	}
	a{
		text-decoration: none;
		color: #fff;
	}
	.mr{
		margin-right: 10px;
	}
	/* 单行省略 */
	.normal{
		overflow: hidden;
		text-overflow: ellipsis; 
		white-space: nowrap;
	}
	/* 上下居中 */
	.flexAlign{
		display: flex;
		align-items: center;
	}
	/* 上下左右居中 */
	.flexCenter{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	/* 竖着上下居中 */
	.flexOnCenter{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.flexOnBetween{
		display: flex;
		justify-content: space-between;
		flex-direction: column;
	}
	.flexOnAround{
		display: flex;
		justify-content: space-around;
		flex-direction: column;
	}
	.flexAround{
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	.flexBetween{
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.flexWrap{
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
	.flexEnd{
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
	#app {
		font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		height: 100vh;
		/* text-align: center; */
		/* color: #2c3e50; */
		/* background-color: #f0f3f8; */
	}

	#nav {
		padding: 30px;
	}

	#nav a {
		font-weight: bold;
		color: #2c3e50;
	}

	#nav a.router-link-exact-active {
		color: #42b983;
	}

	/* 表格全局单行显示，超出省略 */
	.el-table .cell {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	/* 表格操作列/状态列不换行 */
	.el-table .cell .el-button+.el-button {
		margin-left: 4px;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: all .2s ease;
	}

	.fade-enter,
	.fade-leave-active {
		opacity: 0;
	}
</style>
